module.exports = __webpack_public_path__ + "img/lootbox-legendary-11.d6fef1fd.jpg";